import React, { createContext, FC, PropsWithChildren, useContext, useMemo, useState } from 'react';

interface AppNavBarContextProps {
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}

export const AppNavBarContext = createContext<AppNavBarContextProps | undefined>(undefined);

export const useAppNavBarContext = () => {
  const value = useContext(AppNavBarContext);
  if (!value) {
    throw new Error(
      'no value found for AppNavBarContextProps, did you forget to wrap it in a provider?'
    );
  }
  return value;
};

export const AppNavBarContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const value = useMemo(() => {
    return {
      isDrawerOpen,
      setIsDrawerOpen
    };
  }, [isDrawerOpen]);
  return <AppNavBarContext.Provider value={value}>{children}</AppNavBarContext.Provider>;
};
